import { useState } from "react";
import { Play } from "lucide-react";
import { DEMO_POSTER, DEMO_DURATION } from "@/lib/demo";
import { WatchDemoModal } from "@/components/WatchDemoModal";
import { logEvent } from "@/lib/analytics";

// Reusable video thumbnail (poster + play button) that opens the Watch Demo modal.
export function DemoThumbnail({ eyebrow = "Product Demo", title = "Watch RecoverOS in Action", subtitle, onStartTrial, onBookDemo, source = "thumbnail", className = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={className} data-testid="demo-thumbnail">
      {eyebrow && <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#0B3D91]">{eyebrow}</span>}
      <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-950" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{title}</h2>
      {subtitle && <p className="mt-3 text-slate-600 max-w-2xl mx-auto">{subtitle}</p>}
      <button
        onClick={() => { logEvent("demo_thumbnail_clicked", { source }); setOpen(true); }}
        className="group mt-8 relative block w-full max-w-3xl mx-auto overflow-hidden border border-slate-200 bg-slate-900 shadow-[0_30px_70px_-24px_rgba(11,61,145,0.5)]"
        data-testid="demo-thumbnail-play"
        aria-label="Play RecoverOS demo"
      >
        <div className="relative aspect-video">
          <img src={DEMO_POSTER} alt="RecoverOS demo preview" className="h-full w-full object-cover opacity-80 transition-opacity group-hover:opacity-100" />
          <div className="absolute inset-0 flex items-center justify-center" style={{ background: "rgba(11,61,145,0.35)" }}>
            <span className="flex h-20 w-20 items-center justify-center rounded-full bg-white/95 text-[#0B3D91] shadow-lg transition-transform group-hover:scale-110">
              <Play size={34} fill="currentColor" />
            </span>
          </div>
          <span className="absolute bottom-3 right-3 rounded-full bg-black/60 px-2.5 py-1 text-xs font-semibold text-white">{DEMO_DURATION}</span>
        </div>
      </button>
      <WatchDemoModal open={open} onOpenChange={setOpen} onStartTrial={onStartTrial} onBookDemo={onBookDemo} source={source} />
    </div>
  );
}
